export default class Address {
    constructor(
        public readonly countryCode: string,
        public readonly region: string | null,
        public readonly zipCode: string,
        public readonly settlement: string,
        public readonly addressLine: string
    ) {
    }
}